import { render } from "./othersDialog.vue?vue&type=template&id=6ff70ee3&scoped=true"
import script from "./othersDialog.vue?vue&type=script&lang=js"
export * from "./othersDialog.vue?vue&type=script&lang=js"

import "./othersDialog.vue?vue&type=style&index=0&id=6ff70ee3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff70ee3"]])

export default __exports__